import androidx.compose.runtime.*
import org.jetbrains.compose.web.dom.*

// Dětská sekce: stejný vzhled jako Hráči (medailonky), ale data jsou 100% ze sgbowling vlastních
// tabulek (sg_child*) - žádná vazba na bowlingligu. Průměr v medailonku se počítá z typu hry, ve
// kterém má dítě NEJVÍC odehraných her (klasika/mantinely/dvojice) - u menších dětí to typicky bude
// "s mantinely", u starších "klasika". Typ se u medailonku zobrazuje, aby bylo jasné, k čemu se
// průměr vztahuje (mantinelové skóre jinak vypadá než klasika).

data class ChildStat(val gameType: String, val games: Int, val average: Double, val maxScore: Int)

@Composable
fun ChildrenScreen(onOpenChild: (String) -> Unit) {
    var children by remember { mutableStateOf<List<SgChildDto>>(emptyList()) }
    var stats by remember { mutableStateOf<Map<String, ChildStat>>(emptyMap()) }
    var error by remember { mutableStateOf<String?>(null) }
    var loading by remember { mutableStateOf(true) }

    LaunchedEffect(Unit) {
        try {
            children = Api.fetchChildren()
            val rounds = Api.fetchChildRounds()
            val scores = Api.fetchChildRoundScores(roundIds = rounds.map { it.id })
            stats = scores.groupBy { it.childId }.mapValues { (_, sc) ->
                val best = sc.groupBy { it.gameType }.entries.maxByOrNull { it.value.size }!!
                val typeScores = best.value
                ChildStat(best.key, typeScores.size, (typeScores.map { it.score }.average() * 10).toInt() / 10.0, typeScores.maxOf { it.score })
            }
        } catch (e: Throwable) {
            error = e.apiMessage()
        } finally {
            loading = false
        }
    }

    when {
        loading -> Div(attrs = { classes("card") }) { P { Text("Načítám…") } }
        children.isEmpty() -> Div(attrs = { classes("card") }) {
            P(attrs = { classes("muted") }) { Text("Zatím žádné děti.") }
            error?.let { Div(attrs = { classes("muted") }) { Text("Detail: $it") } }
        }
        else -> {
            Div(attrs = { classes("medallion-grid") }) {
                children.sortedByDescending { stats[it.id]?.average ?: -1.0 }.forEach { child ->
                    ChildMedallion(child, stats[child.id], onOpenChild)
                }
            }
        }
    }
}

@Composable
private fun ChildMedallion(child: SgChildDto, stat: ChildStat?, onOpen: (String) -> Unit) {
    Div(attrs = {
        classes("card", "medallion")
        onClick { onOpen(child.id) }
    }) {
        val photo = child.photoUrl
        if (!photo.isNullOrBlank()) {
            Img(src = photo, alt = child.displayName, attrs = { classes("medallion-photo") })
        } else {
            Div(attrs = { classes("avatar-placeholder") }) { Text(child.displayName.take(1)) }
        }
        H3 { Text(child.displayName) }
        child.nickname?.takeIf { it.isNotBlank() }?.let { Div(attrs = { classes("medallion-nick") }) { Text("„$it“") } }
        if (stat != null) {
            Div(attrs = { classes("medallion-avg") }) { Text("Ø ${stat.average}") }
            Div(attrs = { classes("medallion-sub") }) { Text("${stat.games} her · max ${stat.maxScore} · ${childBowlingTypeLabel(stat.gameType)}") }
        } else {
            Div(attrs = { classes("muted") }) { Text("bez odehraných her") }
        }
    }
}
